import { post } from "@/utils/request";
import type { Recall, CommonForm, Detail } from "@/types/procss";
import type { Response } from "@/types/axios";


// 装修、采购协议变更申请详情
export const decproChangeDetail = (params: { Id: number | string }) =>
  post("/api/decproChange/decproChangeDetail", params);

// 房屋租赁变更申请详情
export const houseRentChangeDetail = (params: { Id: number | string }) =>
  post("/api/houseRentChange/houseRentChangeDetail", params);

// 税务迁址申请详情
export const taxAddressChangeDetail = (params: { Id: number | string }) =>
  post("/api/resourceChange/taxAddressChangeDetail", params);
  
// 印章证照刻制申请详情
export const sealLicenseChangeDetail = (params: { Id: number | string }) =>
  post("/api/resourceChange/sealLicenseChangeDetail", params);

// 获取资料及用印申请详情
export const resourceChangeDetail = (params: { Id: number | string }) =>
  post("/api/resourceChange/resourceChangeDetail", params);

 

